export default __webpack_public_path__ + "static/bestview-grounds3-e7a59de4d5854b5a955b4ff6a48885b1.jpg";